import wixAnimations from 'wix-animations';
import {getBoundingRect} from 'wix-window';

export default function editorAnimation() {
    let currentImg = '#desktopImg';
    let animationComplete = true;
    let animation = {
        duration: 400,
        delay: 100
    }

    wixAnimations.timeline().add($w('#tabletImg, #mobileImg,#breakpointsImg'),{opacity:0, duration:0 }).play();

    getBoundingRect()
        .then((windowSizeInfo) => {

            let windowWidth = windowSizeInfo.window.width;
            let handleMove = 0.125 * windowWidth;

        });

    $w('#desktopHover').onMouseIn(() => {
        if (currentImg === '#desktopImg' || !animationComplete) return;
        animationComplete = false;
		
        wixAnimations.timeline()
            .add($w('#handleL'), { x: 0, duration: 600 })
            .add($w('#handleR'), { x: 0, duration: 600 }, 0)
            .add($w(currentImg), { opacity: 0, duration: 400 }, 100)
            .add($w('#desktopImg'), { opacity: 1, duration: 400 },100)
            .play()
            .onComplete(()=>{
                currentImg = '#desktopImg';
                animationComplete = true;
            });

        
    });

    $w('#tabletHover').onMouseIn(() => {
        if (currentImg === '#tabletImg' || !animationComplete) return;
		animationComplete = false;
        getBoundingRect()
            .then((windowSizeInfo) => {

                let windowWidth = windowSizeInfo.window.width;
                let handleMove = 0.125 * windowWidth;
                wixAnimations.timeline()
                    .add($w('#handleL'), { x: handleMove, duration: 600 })
                    .add($w('#handleR'), { x: -handleMove, duration: 600 }, 0)
                    .add($w(currentImg), { opacity: 0, duration: 400 }, 100)
                    .add($w('#tabletImg'), { opacity: 1, duration: 400 },100)
                    .play()
                    .onComplete(()=>{
                        currentImg = '#tabletImg';
                        animationComplete = true;
                    });

            });
        
        
    })

    $w('#mobileHover').onMouseIn(() => {
        if (currentImg === '#mobileImg' || !animationComplete) return;
        animationComplete = false;
		
        getBoundingRect()
            .then((windowSizeInfo) => {

                let windowWidth = windowSizeInfo.window.width;
                let handleMove = 0.2 * windowWidth;
                wixAnimations.timeline()
                    .add($w('#handleL'), { x: handleMove, duration: 600 })
                    .add($w('#handleR'), { x: -handleMove, duration: 600 }, 0)
                    .add($w(currentImg), { opacity: 0, duration: 400 }, 100)
                    .add($w('#mobileImg'), { opacity: 1, duration: 400 },100)
                    .play()
                    .onComplete(()=>{
                        currentImg = '#mobileImg';
                        animationComplete = true;
                    });

            });
       
        
    });

    let breakpointsTimeline = wixAnimations.timeline().add( $w('#breakpointsImg'), {opacity:1, duration:300});

    $w('#breakpointHover').onMouseIn(()=>{
       breakpointsTimeline.play();
    })

     $w('#breakpointHover').onMouseOut(()=>{
        breakpointsTimeline.reverse();
    })

}


export function stam(){
    console.log('hi')
}